var _defs, _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeoLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 513.66 123.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:#0b1327;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 72.65,
    y1: 41.3,
    x2: 89.49,
    y2: 41.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f42bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f62ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.38,
    y1: 56.89,
    x2: 130.08,
    y2: 56.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7620ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ddcfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 130.08,
    y1: 54.31,
    x2: 133.79,
    y2: 54.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 66.98,
    y1: 29.03,
    x2: 72.65,
    y2: 29.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 105.03,
    y1: 63.97,
    x2: 129.27,
    y2: 21.98,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "neo-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.37 50.49 89.49 50.36 72.65 32.1 89.37 50.49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.36,57.81l-6.87-7.45-.12.14L72.65,32.1,67,26A16.88,16.88,0,0,0,55.61,21.4h-.17a16.89,16.89,0,0,0-12.28,5.29L8,63.87A16.91,16.91,0,0,0,32.57,87.1L55.2,63.16,76.74,86.85a16.9,16.9,0,0,0,12.42,5.54h.08A16.91,16.91,0,0,0,101.64,87l28.44-30.67-1.43,1.54A22,22,0,0,1,96.36,57.81Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "133.79 52.3 133.79 52.3 130.08 56.31 133.79 52.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68,26.93c-.31-.34-.64-.66-1-1l5.67,6.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.22,25.91a16.9,16.9,0,0,0-23.89.9L101.19,37.75,89.49,50.36l6.87,7.45a22,22,0,0,0,32.29,0l1.43-1.54,3.71-4,2.33-2.51A16.91,16.91,0,0,0,135.22,25.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.82,48H195.74L180.4,11.83a143.14,143.14,0,0,1,1.16,17.94V48h-7.77V3.28H184.6l15.61,36.27a110.94,110.94,0,0,1-1.16-15.29v-21h7.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245,33.46H223.46c.59,7,3.89,9.26,8.42,9.26,3.05,0,5.57-1,8.55-3l3.44,4.73a19.72,19.72,0,0,1-12.7,4.6c-10.62,0-16.32-7.06-16.32-17.87,0-10.43,5.51-18.33,15.22-18.33s15.09,6.47,15.09,17.29C245.16,31.19,245,32.55,245,33.46Zm-8-5.77c0-5.63-2-9-6.68-9-3.88,0-6.34,2.59-6.8,9.39h13.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.66,30.87c0,10.81-6,18.13-16.13,18.13s-16.12-6.86-16.12-18.13c0-10.75,6-18.07,16.19-18.07S282.66,19.66,282.66,30.87Zm-23.51,0c0,8.22,2.53,11.85,7.38,11.85s7.39-3.69,7.39-11.85-2.53-11.79-7.32-11.79S259.15,22.77,259.15,30.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.65,73.67h-10.9v34.67h-5.41V73.67H174.16V69.05h28.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.65,95.11H208.49c.51,7,3.76,9.64,8.1,9.64a12.62,12.62,0,0,0,7.81-2.63l2.28,3.14A16.35,16.35,0,0,1,216.19,109c-8.38,0-13.29-5.87-13.29-15.39,0-9.36,4.74-16,12.49-16,8.1,0,12.38,5.65,12.38,14.83C227.77,93.46,227.71,94.43,227.65,95.11Zm-5.07-4.22c0-5.87-2.34-9.13-7.07-9.13-4,0-6.62,2.8-7,9.47h14.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.28,80.85l-2.51,3.31a10.27,10.27,0,0,0-6.44-2.22c-4.73,0-7.7,3.7-7.7,11.52s3,11.12,7.7,11.12a11.18,11.18,0,0,0,6.56-2.28l2.39,3.42a14.2,14.2,0,0,1-9.18,3.3C239,109,234,103.26,234,93.57s5-16,13.12-16A13.33,13.33,0,0,1,256.28,80.85Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.28,86.78v21.56H281V87.52c0-4.5-1.93-5.81-4.79-5.81-3.25,0-5.59,2.11-7.58,5.24v21.39h-5.25V66.25l5.25-.57V82.45a10.78,10.78,0,0,1,8.9-4.85C283,77.6,286.28,81.14,286.28,86.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.7,86.78v21.56h-5.25V87.52c0-4.5-1.82-5.81-4.73-5.81-3.36,0-5.64,2.11-7.64,5.3v21.33h-5.25v-30h4.51l.45,4.44A10.92,10.92,0,0,1,311,77.6C316.51,77.6,319.7,81.08,319.7,86.78Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.89,93.28c0,9.3-4.9,15.74-13.4,15.74s-13.4-6.15-13.4-15.68c0-9.29,4.9-15.74,13.46-15.74S354.89,83.76,354.89,93.28Zm-21.16.06c0,7.81,2.74,11.46,7.76,11.46s7.75-3.65,7.75-11.52-2.73-11.46-7.69-11.46S333.73,85.47,333.73,93.34Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.27,102.41V66.2l5.25-.63V102.3c0,1.59.51,2.39,1.88,2.39a5.09,5.09,0,0,0,1.94-.34l1.37,3.65a8.77,8.77,0,0,1-4.16,1C365.73,109,363.27,106.69,363.27,102.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M404.62,93.28c0,9.3-4.9,15.74-13.4,15.74s-13.4-6.15-13.4-15.68c0-9.29,4.9-15.74,13.46-15.74S404.62,83.76,404.62,93.28Zm-21.16.06c0,7.81,2.74,11.46,7.76,11.46S399,101.15,399,93.28s-2.74-11.46-7.7-11.46S383.46,85.47,383.46,93.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M437.53,79.65a29.2,29.2,0,0,1-8.78.92c3.53,1.59,5.3,4.1,5.3,7.58,0,5.93-4.28,10.21-11.46,10.21a12.11,12.11,0,0,1-3.82-.57,3.62,3.62,0,0,0-1.49,2.79c0,1.37.86,2.46,3.94,2.46H426c6.16,0,10.26,3.53,10.26,8.32,0,5.82-4.79,9.13-14.08,9.13-9.81,0-12.89-3-12.89-9.13H414c0,3.42,1.54,5,8.16,5s8.78-1.65,8.78-4.67c0-2.86-2.28-4.28-6-4.28h-4.74c-5.36,0-7.75-2.68-7.75-5.7a6.55,6.55,0,0,1,3.3-5.31,8.61,8.61,0,0,1-5.07-8.33c0-6.15,5-10.49,11.58-10.49,7.47.17,10.2-1.08,13.74-2.68ZM416,88.09c0,4,2.22,6.79,6.33,6.79s6.33-2.51,6.33-6.84-2.17-6.67-6.44-6.67C418.2,81.37,416,84.16,416,88.09Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M449.22,67.45a3.68,3.68,0,1,1-3.71-3.59A3.49,3.49,0,0,1,449.22,67.45Zm-1,40.89H443v-30h5.24Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M481.61,95.11H462.45c.52,7,3.77,9.64,8.1,9.64a12.6,12.6,0,0,0,7.81-2.63l2.28,3.14A16.35,16.35,0,0,1,470.15,109c-8.38,0-13.29-5.87-13.29-15.39,0-9.36,4.74-16,12.49-16,8.1,0,12.38,5.65,12.38,14.83C481.73,93.46,481.67,94.43,481.61,95.11Zm-5.07-4.22c0-5.87-2.34-9.13-7.07-9.13-4,0-6.62,2.8-7,9.47h14.09Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M508.48,81l-2.23,3.31a13.88,13.88,0,0,0-7.81-2.57c-3.42,0-5.53,1.54-5.53,3.94s1.59,3.59,6.44,4.85c6.33,1.59,10,4.1,10,9.35,0,6.27-5.76,9.12-11.86,9.12a16.66,16.66,0,0,1-11.35-3.93l2.8-3.19a13.62,13.62,0,0,0,8.44,2.9c3.93,0,6.44-1.71,6.44-4.56s-1.48-4.1-7.3-5.64c-6.5-1.71-9.07-4.51-9.07-8.73,0-4.79,4.62-8.27,10.84-8.27A16,16,0,0,1,508.48,81Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoLogoWhite);
export default __webpack_public_path__ + "static/media/neo-logo-white.67e3fe36b531c827a209b064e1562da4.svg";
export { ForwardRef as ReactComponent };